<!-- 签字扫描件弹窗 -->
<template>
    <custom-modal
        width="400px"
        title="签字扫描件"
        :visible="visible"
        @on-close="handleClose"
    >
        <a-spin :spinning="loading">
            <a-form-model ref="form" v-bind="formLayout" :model="form" :rules="formRules">
                <a-form-model-item label="签字扫描件" prop="signedDocuments">
                    <custom-upload-file v-model="form.signedDocuments" :file-number="10" />
                </a-form-model-item>
            </a-form-model>
        </a-spin>
        <template slot="customFooter">
            <a-button type="primary" :loading="loading" @click="handleOk">
                确定
            </a-button>
        </template>
    </custom-modal>
</template>

<script>
import {
    Button as AButton,
    FormModel as AFormModel,
    Spin as ASpin
} from 'ant-design-vue'
import CustomModal from '@components/CustomModal'
import CustomUploadFile from '@weights/CreateForm/components/UploadFile'
import { saveSalarySignDocuments, getSalaryDocumentsById } from '@/service/project/attendanceAndSalaryServices'

export default {
    name: 'SignFileModal',
    components: {
        AButton,
        AFormModel,
        AFormModelItem: AFormModel.Item,
        CustomModal,
        ASpin,
        CustomUploadFile
    },
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loading: false,
            visible: false,
            form: {
                signedDocuments: undefined
            },
            formLayout: {
                labelCol: {
                    span: 24
                },
                wrapperCol: {
                    span: 24
                }
            },
            formRules: {
                signedDocuments: {
                    required: true,
                    message: '此项为必填'
                }
            }
        }
    },
    methods: {
        handleClose() {
            this.visible = false
        },
        async handleOk() {
            this.loading = true
            try {
                await saveSalarySignDocuments({
                    signedDocuments: this.form.signedDocuments,
                    id: this.params.salaryMonthId
                })
                this.handleClose()
                this.$emit('on-refresh')
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.loading = false
            }
        },
        async getInfo() {
            try {
                this.loading = true

                const { signedDocuments } = await getSalaryDocumentsById({
                    id: this.params.salaryMonthId
                })
                this.form.signedDocuments = signedDocuments || undefined
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        },
        open() {
            this.visible = true
            this.getInfo()
        }
    }
}
</script>
